module.exports = __webpack_public_path__ + "img/sdg.60e9a78b.png";